import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material'
import React, { useContext, useState } from 'react'
import { GuardarNuevoNodo } from '../../helpers/ActivosHelper'
import { ActivosContext } from '../../pages/catalogos/ActivosPage'

export const ModalCambiaPadreComponent = () => {
    const {modalCambiarNodo, setModalCambiarNodo, activoSeleccionado, obtenerActivos} = useContext(ActivosContext)
    const [nuevoIdPadre, setNuevoIdPadre] = useState();

    const handleClose = () => {
        setModalCambiarNodo(false)
    }

    const guardarNodo = () => {
        GuardarNuevoNodo(activoSeleccionado.key, nuevoIdPadre).then(response => {
            console.log('respuesta de cambio de nodo', response);
            obtenerActivos();
            setModalCambiarNodo(false)
        })
    }

  return (
    <Dialog open={modalCambiarNodo} onClose={handleClose}>
        <DialogTitle>
            Cambiar instalacion "padre" {activoSeleccionado?.title}
        </DialogTitle>
        <DialogContent>
            <TextField 
                label={activoSeleccionado?.key}
                onChange={(newValue) => {setNuevoIdPadre(newValue.target.value)}}
            />
        </DialogContent>
        <DialogActions>
            <Button
                onClick={() => {handleClose()}}
            >
                Cancelar
            </Button>
            <Button
                onClick={() => {guardarNodo()}}
            >
                Guardar
            </Button>
        </DialogActions>
    </Dialog>
  )
}
